import React from 'react';

const SecOneAboutMe = () => {
    return (
        <div>
             <div className="about-container">
                <div className="break"></div>
                <div className="content">
            <h1 id="about-page-subheader">About Us</h1>
                    <p id="about-content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                
                </div>
                <div className="break"></div>
                <div id="pic-div">
                   <img alt="" id="pic-test" src="https://i.imgur.com/5i93lwO.jpg"/>
                </div>
                <div className="break"></div>
                
            </div>
        </div>
    );
};

export default SecOneAboutMe;